import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _5e0c3d92 = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _e2b8dd54 = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _ae601978 = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _22a94aec = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _7cc2d2f9 = () => interopDefault(import('../pages/_market/_language/cart/index.vue'
/* webpackChunkName: "pages/_market/_language/cart/index" */
));

const _1e6731da = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _2de5a646 = () => interopDefault(import('../pages/_market/_language/login/index.vue'
/* webpackChunkName: "pages/_market/_language/login/index" */
));

const _5cb3a641 = () => interopDefault(import('../pages/_market/_language/lost-password/index.vue'
/* webpackChunkName: "pages/_market/_language/lost-password/index" */
));

const _5c42f872 = () => interopDefault(import('../pages/_market/_language/reset-password/index.vue'
/* webpackChunkName: "pages/_market/_language/reset-password/index" */
));

const _6ad5091e = () => interopDefault(import('../pages/_market/_language/signup/index.vue'
/* webpackChunkName: "pages/_market/_language/signup/index" */
));

const _e51707dc = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _2e563f47 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _d47aac38 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _24ca2cc8 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _2a0f0834 = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _32cb1687 = () => interopDefault(import('../pages/_market/_language/poc/grid.vue'
/* webpackChunkName: "pages/_market/_language/poc/grid" */
));

const _e5c11076 = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _6982a55c = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _59eda704 = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _6f76bb2e = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _2092d1c4 = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

const _fd15c9f6 = () => interopDefault(import('../pages/_market/_language/t/delivery.vue'
/* webpackChunkName: "pages/_market/_language/t/delivery" */
));

const _11f4ccb0 = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

const _aab3063a = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

const _3e6a4ff6 = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

const _923dd296 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

const _23ed5862 = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

const _36078869 = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

const _0d7e5638 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _2864a9f4 = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _2937d0bb = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _27d4c204 = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _f386c064 = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _3f9770ca = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _21073ac8 = () => interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
));

const _7914f29f = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _b45ee7ba = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _b1672e04 = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _d29c3ee2 = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _94706208 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _b99a2a28 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _379de72c = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _9c1cc170 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _4f695e5a = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _494f5bde = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _63a567cc = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _3c50b6a6 = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

const _40bc1bde = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _5b8bd00c = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _5e0c3d92,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _e2b8dd54,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _ae601978,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _22a94aec,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _7cc2d2f9,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _1e6731da,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _2de5a646,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _5cb3a641,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _5c42f872,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _6ad5091e,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _e51707dc,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _2e563f47,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _d47aac38,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _24ca2cc8,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _2a0f0834,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _32cb1687,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _e5c11076,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _6982a55c,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _59eda704,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _6f76bb2e,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _2092d1c4,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/delivery",
      component: _fd15c9f6,
      name: "market-language-t-delivery"
    }, {
      path: "/:market/:language/t/login",
      component: _11f4ccb0,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _aab3063a,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _3e6a4ff6,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _923dd296,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _23ed5862,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/signup",
      component: _36078869,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _0d7e5638,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _2864a9f4,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _2937d0bb,
      children: [{
        path: "",
        component: _27d4c204,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _f386c064,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _3f9770ca,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _21073ac8,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _7914f29f,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _b45ee7ba,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _b1672e04,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _d29c3ee2,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _94706208,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _b99a2a28,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _379de72c,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _9c1cc170,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _4f695e5a,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _494f5bde,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _63a567cc,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _3c50b6a6,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _40bc1bde,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _5b8bd00c,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}